import { Dictionary } from 'lodash';

import { IGroup, ISimpleItem, IItemGroupId } from '../types';

export const removeGroup = ({
  items,
  groups,
  parameterId,
  groupId,
}: {
  items: Dictionary<ISimpleItem[]>;
  groups: IGroup[];
  parameterId: number;
  groupId: IItemGroupId;
}) => {
  const possibleGroup = groups.find(
    group => group.parameter.id === parameterId
  );
  if (!possibleGroup) {
    return {};
  }
  const possibleItemGroup = possibleGroup.itemGroups.find(
    itemGroup => itemGroup.id === groupId
  );
  if (!possibleItemGroup) {
    return {};
  }
  const removedGroupItems = possibleItemGroup.items;
  const itemsCopy = [...items[parameterId], ...removedGroupItems];

  return {
    groups: groups.map(group => {
      if (group.parameter.id === parameterId) {
        return {
          ...group,
          itemGroups: group.itemGroups.filter(
            itemGroup => itemGroup.id !== groupId
          ),
        };
      }
      return group;
    }),
    items: {
      ...items,
      [parameterId]: itemsCopy,
    },
  };
};



// WEBPACK FOOTER //
// ./src/views/Admin/ItemGroups/services/removeGroup.ts